import { Flex, Icon, Td, Text, Tr, Button } from '@chakra-ui/react'
import { GrUpdate } from 'react-icons/gr'
import { ConfirmDialog } from '../ConfirmDialog'
import { api } from '../../../../../services/api'
import { useState } from 'react'
import { ValidarNota } from '../../ValidarNota'
import { FaExternalLinkAlt } from 'react-icons/fa'

export function TrItem({ data, loading, idx, resultado, getNotasAntecipadas, handleNunotaToUpdate, isNotasValidadas }) {
  const [loadingUpdate, setLoadingUpdate] = useState(false)

  async function updatePeso(nunota, peso) {
    setLoadingUpdate(true)

    await new Promise((resolve) => setTimeout(resolve, 1000))

    const response = await api.post('/site/v2/pedido/atualiza-peso-info-nota', {
      numero_nota: nunota,
      peso: peso,
    })

    console.log('response: ', response)

    resultado({
      codParc: '',
      pedido: '',
      dataDe: '',
      dataAte: '',
      pendente: '',
      nfe: '',
    })

    setLoadingUpdate(false)
  }

  return (
    <Tr id="id_tr" key={data.numero_unico}>
      <Td padding=".3rem" textAlign="center">
        <Text as="a" href={data.link_pdf} target="_blank" rel="noreferrer" color={'blue.500'} textDecoration="underline" cursor="pointer">
          {data.numero_pedido}
        </Text>
      </Td>

      <Td padding=".3rem" textAlign="center">
        {data.numero_unico_origem}
      </Td>
      <Td>{data.data_saida}</Td>
      <Td padding=".3rem" textAlign="center" style={{ position: 'relative', width: '160px' }}>
        <Button
          href={`${process.env.REACT_APP_BASE_URL}/site/v2/orcamento/visualiza-nota-fisc/${data.numero_unico}`}
          target="_blank"
          rel="noreferrer"
          as="a"
          colorScheme="blue"
          size="sm"
        >
          Visualizar
        </Button>
      </Td>

      {/* <Td padding=".3rem" textAlign="center" style={{ position: "relative", width: "160px" }}>
        {new Date(data.data_saida).toLocaleDateString("pt-BR", {
          timeZone: "UTC",
        })}
      </Td> */}

      <Td padding=".3rem" textAlign="center" style={{ position: 'relative', width: '190px' }}>
        <Text as="p" noOfLines={1} style={{ textAlign: 'left' }}>
          {data.nome_parc.length > 20 ? data.nome_parc.slice(0, 20) + '...' : data.nome_parc}
        </Text>
      </Td>
      <Td padding=".3rem" textAlign="center" style={{ position: 'relative', width: '160px' }}>
        {data.nome_vendedor}
      </Td>
      <Td padding=".3rem" textAlign="center" style={{ position: 'relative', width: '160px' }}>
        {data.peso_total} kg
      </Td>
      <Td padding=".3rem" textAlign="center" style={{ position: 'relative', width: '160px' }}>
        <Flex alignItems="center" justifyContent="space-between" gap={2} maxW="80px" mx="auto">
          {data.peso_real} kg{' '}
          <Icon
            as={GrUpdate}
            color="#378BBF"
            size={20}
            cursor="pointer"
            transform={loadingUpdate ? 'rotate(360deg)' : ''}
            transition={loadingUpdate ? 'all 1s' : ''}
            onClick={() => updatePeso(data.numero_unico, data.peso_real)}
          />
        </Flex>
      </Td>
      <Td padding=".3rem" textAlign="center" style={{ position: 'relative', width: '190px' }}>
        {data.quantidades_caixa}
      </Td>
      <Td padding=".3rem" textAlign="center" style={{ position: 'relative', width: '190px' }}>
        {data.transportadora.length > 20 ? data.transportadora.slice(0, 20) + '...' : data.transportadora}
      </Td>
      <Td padding=".3rem" textAlign="center" style={{ position: 'relative', width: '110px' }}>
        {data.existe_remessa === 'S' ? 'Sim' : 'Não'}
      </Td>
      <Td padding=".3rem" textAlign="center" style={{ position: 'relative', width: '160px' }}>
        R${' '}
        {data.valor_nota.toLocaleString('pt-BR', {
          style: 'currency',
          currency: 'BRL',
        })}
      </Td>

      <Td padding=".3rem" textAlign="center" style={{ width: '100px', posiotion: 'relative' }}>
        {!isNotasValidadas && <ConfirmDialog item={data} resultado={resultado} />}
        {isNotasValidadas && (
          <Flex flexDir="column">
            <Text>{data.usuario_nfe_validada}</Text>
            <Text>{data.data_nfe_validada}</Text>
          </Flex>
        )}
      </Td>

      <Td textAlign="center">
        {/* <CheckboxItem data={data} handleNunotaToUpdate={handleNunotaToUpdate} /> */}
        {!isNotasValidadas && <ValidarNota nunotaToUpdate={data.numero_unico} resultado={resultado} />}
        {isNotasValidadas && (
          <Button
            as="a"
            href={data.link_nfe_validada}
            target="_blank"
            rel="noreferrer"
            colorScheme="blue"
            size="sm"
            leftIcon={<Icon as={FaExternalLinkAlt} />}
          >
            Link
          </Button>
        )}
      </Td>
    </Tr>
  )
}
